export function defaultResolveComponent( loadedModule ){

  return loadedModule.__esModule ?
    loadedModule.default :
    loadedModule.default || loadedModule;
}
